export const SCOPE = 'tempDashboardTab';

export const INIT = `${SCOPE}/INIT`;
export const SETUP = `${SCOPE}/SETUP`;
export const DONE = `${SCOPE}/DONE`;
